import React, { useEffect, useState } from 'react';
import MainApp from './MainApp';
import Login from './Login';
import UserAdmin from './UserAdmin';
import { apiFetch, authToken, saveAuthToken } from './api';

const App = () => {
  const [user, setUser] = useState(undefined);
  const [showUsers, setShowUsers] = useState(false);

  const logout = () => {
    // The remembered list and page are per browser session (see MainApp), so a
    // deliberate logout clears them: the next login opens on the default.
    try { sessionStorage.removeItem('bse2Group'); sessionStorage.removeItem('bse2Page'); } catch (_error) { /* private mode */ }
    saveAuthToken('');
    setShowUsers(false);
    setUser(null);
  };

  useEffect(() => {
    const expired = () => logout();
    window.addEventListener('bse2-auth-expired', expired);
    if (!authToken()) {
      setUser(null);
    } else {
      apiFetch('/api/auth/me')
        .then(async (response) => {
          const body = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(body.error || 'Login expired');
          setUser(body.user);
        })
        .catch(() => logout());
    }
    return () => window.removeEventListener('bse2-auth-expired', expired);
  }, []);

  if (user === undefined) return <div className="auth-loading">Checking login…</div>;
  if (!user) return <Login onLogin={setUser} />;

  return (
    <>
      <MainApp
        username={user.username}
        isAdmin={user.isAdmin}
        canTrade={user.canTrade}
        riskPerTrade={user.riskPerTrade}
        onUpdated={setUser}
        onManageUsers={() => setShowUsers(true)}
        onLogout={logout}
      />
      {showUsers && user.isAdmin && <UserAdmin onClose={() => setShowUsers(false)} />}
    </>
  );
};

export default App;
